"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var twitterTheme = {
  tenant: {
    primary: "#1da1f2"
  }
};
var _default = exports["default"] = twitterTheme;